import React, {useEffect} from 'react'
import {useNavigate, useLocation} from 'react-router-dom'
import {Form, Input, Button, message} from 'antd';
import { login, getUserPerms } from '../../api/user'
import "./index.css"

const userCenterLogin = () => {
    console.log('用于后期token登录')
}

//布局参数
const layout = {
    labelCol: {
        span: 8,
    },
    wrapperCol: {
        span: 16,
    },
};
const tailLayout = {
    wrapperCol: {
        offset: 8,
        span: 16,
    },
};

export default function Login() {
    const navigate = useNavigate();
    const location = useLocation();
    const formRef = React.createRef();
    //判断有无缓存(浏览器缓存，非状态管理器)
    useEffect(() => {
        if (localStorage.getItem("ai-chat-auth-id")) {
            message.success('登录未过期！')
            setTimeout(() => {
                navigate('/Index')
            }, 1000);
        } else {
            //浏览器token认证 、 url带账号密码直接登录（以‘name-’加登录名 开始 ‘pwd-’加密码 结束，有安全隐患不建议使用）
            if (location.search) {
                if (location.search.includes('token=')) {
                    userCenterLoginByToken(location.search.split('token=')[1])
                } else if (location.search.includes('name-')) { // !!!!! 账号密码登录
                    let datas = location.search.substring(1, location.search.length)
                    let values = {user: datas.split('name-')[1].split('pwd-')[0], password: datas.split('pwd-')[1]}
                    onFinish(values)
                }
            }
        }
    })
    const onFinish = (values) => {
        login(values).then(res => {
            if (res.code === 0) {
                message.success('登录成功！')
                localStorage.setItem("ai-chat-auth-id", res.data)
                getUserPerms().then(resf => {
                    if (resf.code * 1 === 0) {
                        localStorage.setItem('ai-chat-user-info', JSON.stringify(resf.data))
                        setTimeout(() => {
                            navigate('/Index', {state: {user: 1, sc: 2}})
                        }, 500);
                    }
                })
            }
        })
    };
    const onReset = () => {
        formRef.current.resetFields();
    };
    const userCenterLoginByToken = (token) => {
        userCenterLogin({token}).then(res => {
            if (res.code === 0) {
                message.success('登录成功！')
                localStorage.setItem("ai-chat-auth-id", res.data)
                getUserPerms().then(resf => {
                    if (resf.code * 1 === 0) {
                        localStorage.setItem('ai-chat-user-info', JSON.stringify(resf.data))
                        setTimeout(() => {
                            navigate('/Index', {state: {user: 1, sc: 2}})
                        }, 500);
                    }
                })
            }
        })
    }
    return (
        <div className="login-wrap">
            <div className="login-content">
                <h1 style={{fontSize: 28}}>智能AI</h1>
                <Form className="login-form" {...layout} ref={formRef} name="control-ref" onFinish={onFinish}>
                    <Form.Item
                        name="user"
                        label="账号"
                        rules={[
                            {
                                required: true,
                            },
                        ]}
                    >
                        <Input/>
                    </Form.Item>
                    <Form.Item
                        name="password"
                        label="密码"
                        rules={[
                            {
                                required: true,
                            },
                        ]}
                    >
                        <Input type="password"/>
                    </Form.Item>
                    <Form.Item
                        noStyle
                        shouldUpdate={(prevValues, currentValues) => prevValues.gender !== currentValues.gender}
                    >
                        {({getFieldValue}) =>
                            getFieldValue('gender') === 'other' ? (
                                <Form.Item
                                    name="customizeGender"
                                    label="Customize Gender"
                                    rules={[
                                        {
                                            required: true,
                                        },
                                    ]}
                                >
                                    <Input/>
                                </Form.Item>
                            ) : null
                        }
                    </Form.Item>
                    <Form.Item {...tailLayout}>
                        <Button type="primary" htmlType="submit" className="buttonMarginRight">
                            登 录
                        </Button>
                        <Button htmlType="button" onClick={onReset}>
                            重 置
                        </Button>
                    </Form.Item>
                </Form>
            </div>
        </div>
    );
}
